/**
 * Copyright © Amazon.com and Affiliates: This deliverable is considered Developed Content as defined in the AWS Service Terms 
 * and the SOW between the parties dated 10/31/2024.
 */

// Icons
export const actionsIconConfig = {
  iconName: "ellipsis-vertical",
  iconType: "fa-solid",
  iconPlacement: "left",
};

export const overflowIconConfig = {
  iconName: "chevron-down",
  iconType: "fa-light",
  iconPlacement: "right"
};

export const sortIconConfig = {
  iconName: "arrow-up-arrow-down",
  iconType: "fa-solid",
  iconPlacement: "right",
};

// End user page
export const sortOptions = [
  { name: 'A to Z', uuid: 'Af8ss5oiy' },
  { name: 'Z to A', uuid: 'ZXghyoiy' },
  { name: 'Score (High to Low)', uuid: 'ScoreHL123' },
  { name: 'Score (Low to High)', uuid: 'ScoreLH456' },
];

// Sort options for pinned reports and dashboards - limited to alphabetical only
export const pinnedReportsSortOptions = [
  { name: 'A to Z', uuid: 'Af8ss5oiy' },
  { name: 'Z to A', uuid: 'ZXghyoiy' }
];

export const contentTypes = [
  { name: 'All', uuid: 'Kr7RCCzf' },
  { name: 'Report', uuid: 'ssReghjkl' },
  { name: 'Dashboard', uuid: 'ssRdhk7hjkl' }
];

export const manageContentTypes = [
  { name: 'All', uuid: 'Kr7RCCzf' },
  { name: 'Report', uuid: 'ssReghjkl' },
  { name: 'Dashboard', uuid: 'ssRdhk7hjkl' },
  { name: 'Tile', uuid: 'ssRdhk8iklm' }
]

export const reportingTypes = [
  { name: 'All', uuid: 'VHa3bndL' },
  { name: 'Custom', uuid: '3456urtsjkl' },
  { name: 'Standard', uuid: '90oipphjkl' }
];

export const subscriptionStatus = [
  { name: 'All', uuid: 'VHa3bndK' },
  { name: 'Subscribed', uuid: '0235456tyrdrtz' },
  { name: 'Unsubscribed', uuid: '9sd567ujlm' }
];

export const PRODUCT_FILTER_OPTIONS = [
  {
    productId: 'Health-All',
    displayName: 'Health',
    status: 'ACTIVE',
    productName: 'Health-All',
  },
  {
    productId: 'STD',
    displayName: 'Leaves/STD',
    status: 'ACTIVE',
    productName: 'Short Term Disability',
  }, {
    productId: 'LTD',
    displayName: 'Leaves/LTD',
    status: 'ACTIVE',
    productName: 'Long Term Disability',
  }, {
    productId: 'FMLA',
    displayName: 'Leaves/FMLA',
    status: 'ACTIVE',
    productName: 'Family Medical Leave Act',
  }, {
    productId: 'LOA',
    displayName: 'Leaves/LOA',
    status: 'ACTIVE',
    productName: 'Leave of Absence',
  }, {
    productId: 'ADA',
    displayName: 'Leaves/ADA',
    status: 'ACTIVE',
    productName: 'Americans with Disabilities Act',
  },
  {
    productId: 'Benefit Calculations',
    displayName: 'Leaves/Benefit Calculations',
    status: 'ACTIVE',
    productName: 'Benefit Calculations',
  },
  {
    productId: 'Pension',
    displayName: 'Pension',
    status: 'ACTIVE',
    productName: 'Pension',
  },
  {
    productId: 'Savings',
    displayName: 'Savings',
    status: 'ACTIVE',
    productName: 'Savings',
  },
]

export const tags = [
  'Leave',
  'Cancelled Leaves',
  'Open Leave',
  'Close Leave',
  'Claims',
  'New Claims',
  'Closed Claims',
  'Denied Claims',
  'Incidence Rate',
  'Demographics',
  'Eligibility',
  'Active Population',
  'Covered Lives',
  'Leave Plan',
  'Tasks',
  'Open Tasks',
  'Closed Tasks',
  'Payroll',
  'Payment',
  'Over Payment',
  'Return To Work (RTW)',
  'Diagnosis',
  'Benefit Pay',
  'Earnings Code',
  'Intermittent',
] as const;

export const tileDimensions = [
  {
    label: "KPI",
    width: "282",
    height: "246",
  },
  {
    label: "Insight - Small",
    width: "282",
    height: "482",
  },
  {
    label: "Donut Chart",
    width: "482",
    height: "482",
  },
  {
    label: "Horizontal Bar",
    width: "754",
    height: "482"
  },
  {
    label: "Filled Map",
    width: "754",
    height: "482"
  },
  {
    label: "Tree Map",
    width: "754",
    height: "482"
  },
  {
    label: "Line Chart",
    width: "754",
    height: "482"
  },
  {
    label: "Vertical Bar",
    width: "754",
    height: "482"
  },
  {
    label: "Waterfall Chart",
    width: "754",
    height: "482"
  },
  {
    label: "Heat Map",
    width: "754",
    height: "482"
  },
  {
    label: "Sankey Diagram",
    width: "754",
    height: "482"
  }
] as const;

export const endUserTableActionOptions = [
  { name: "Favorite", uuid: "235rtyg" },
  { name: "Subscribe", uuid: "2eryhdfxv" },
  { name: "Share", uuid: "share-action-001" },
];

export const pinnedContentActionOptions = [
  { name: "Unfavorite", uuid: "ngeexyhx" },
];

// Basic table actions (Edit/Delete) used across admin and non-admin pages
export const basicTableActionTypes = [
  { name: "Edit", action: "edit", uuid: "hrZJiXql" },
  { name: "Delete", action: "delete", uuid: "QZy3Tq2M" }
];

// Manage Content specific actions (includes sync)
export const manageContentActionTypes = [
  { name: "Edit", action: "edit", uuid: "hrZJiXql" },
  { name: "Delete", action: "delete", uuid: "QZy3Tq2M" },
  { name: "Sync", action: "sync", uuid: "SyncAbc123" }
];

export const defaultModalButtons = [
  {
    text: "Clear All",
    variant: "action",
    type: "button",
    action: "clear",
    uuid: "tRvI19SG"
  },
  {
    text: "Apply",
    variant: "progressive",
    type: "button",
    action: "apply",
    uuid: "ITPBFi4g"
  },
];

// Admin: manage help page
export const modalConfig: any = {
  faq: {
    uuid: "faq-modal",
    headerText: "Add FAQ",
    textInputLabel: "Question",
    textInputUuid: "add-faq",
    textarea1Label: "Answer",
    textarea2Label: "Comment",
    showTextInput: true,
    showTextarea1: true,
    showTextarea2: true,
  },
  glossary: {
    uuid: "glossary-modal",
    headerText: "Add Term",
    textInputLabel: "Term",
    textInputUuid: "add-glossary",
    textarea1Label: "Definition",
    textarea2Label: "Comment",
    showTextInput: true,
    showTextarea1: true,
    showTextarea2: true,
  },
};

// Admin: add content page
export const addContentBasicInputSection = [
  {
    title: 'Basic Information',
    inputs: [
      { uuid: '6SRlc2TV', label: 'Title', value: '', dbField: 'title', type: 'text' },
      {
        uuid: 'TJNBIicy',
        label: 'Type',
        value: '',
        dbField: 'contentType',
        type: 'dropdown',
        dropdownItems: [
          { name: 'Dashboard', disabled: false, uuid: '1', selected: false },
          { name: 'Report', disabled: false, uuid: '2', selected: false },
          { name: 'Tile', disabled: false, uuid: '3', selected: false }
        ]
      },
      { uuid: 'drS08x0g', label: 'Client ID (optional)', value: '', dbField: 'clientCode', type: 'text', helperText: "When left empty, this content will apply to all clients", placeHolderText: "e.g., 1234, 2345, 3456" }
    ],
  },
];

export const addContentQuickSightInputSection = [
  {
    title: 'QuickSight information',
    inputs: [
      { uuid: 'vsexI1y2', label: 'Dashboard ID', value: '', dbField: 'dashboardId', type: 'text' },
      { uuid: 'HyCLMPiA', label: 'Sheet ID', value: '', dbField: 'sheetId', type: 'text' },
      { uuid: 'tdUj72o3', label: 'Visual ID', value: '', dbField: 'visualId', type: 'text' },
    ],
  }
];

export const INPUT_DATE_RANGES = [
  { name: 'Last day', uuid: '1' },
  { name: 'Last 7 days', uuid: '7' },
  { name: 'Last 30 days', uuid: '30' },
  { name: 'Last 90 days', uuid: '90' },
  { name: 'Last 365 days', uuid: '365' },
  { name: 'Prior week', uuid: 'prior-week' },
  { name: 'Prior month', uuid: 'prior-month' },
  { name: 'Prior quarter', uuid: 'prior-quarter' },
  { name: 'Prior year', uuid: 'prior-year' },
] as const;

export const P_AS_OF_DATE_OPTIONS = [
  { name: 'Last day' },
  { name: 'Last 7 days' },
  { name: 'Last 30 days' },
  { name: 'Last 90 days' },
  { name: 'Last 365 days' },
  { name: 'Prior week' },
  { name: 'Prior month' },
  { name: 'Prior quarter' },
  { name: 'Prior year' },
] as const;

export const addContentOtherInputSection = [
  {
    title: 'Other information',
    inputs: [
      { uuid: 'bW8lEnu2', label: 'Tags', value: '', dbField: 'tags', type: 'text', placeHolderText: "e.g., Leave, New Claims, Payroll" },
      {
        uuid: 'TJNBIicy',
        label: 'Reporting Type',
        value: '',
        dbField: 'reportType',
        type: 'dropdown',
        dropdownItems: [
          { name: 'Standard', disabled: false, uuid: '1', selected: false },
          { name: 'Custom', disabled: false, uuid: '2', selected: false },
        ]
      },
    ],
  },
]

export const addContentDisplaySizeOptionsSection = [
  {
    title: "Display size",
    inputs: [
      {
        uuid: 'M)Zv3EKZ', label: 'Content Type', value: '', dbField: 'dimensions', type: 'dropdown',
        dropdownItems: tileDimensions.map((item, index) => ({ name: `${item.label} ${item.height.length ? `- ${item.width} x ${item.height}` : ''}`, selected: false, disabled: false, uuid: index.toString() })),
      }, {
        uuid: 'M)Zv3EJA', label: 'Width', value: '', dbField: 'width', type: 'text', placeHolderText: "",
      },
      {
        uuid: 'M)Zv3EJB', label: 'Height', value: '', dbField: 'height', type: 'text', placeHolderText: ""
      }
    ]
  }
]

export const addContentCheckboxesSection = [
  {
    title: 'Leaves Persona(s)',
    inputs: [
      { uuid: 'ITEdXdwq', label: 'HR', checked: false, type: "checkbox" },
      { uuid: 'IgHCjunl', label: 'Supervisor', checked: false, type: "checkbox" },
    ],
  },
  {
    title: 'Product(s)',
    categories: [
      {
        name: 'Leaves',
        inputs: [
          { uuid: 'Nar6sw31', label: 'ADA', checked: false, type: "checkbox" },
          { uuid: 'NLWBCrgP', label: 'FMLA', checked: false, type: "checkbox" },
          { uuid: '2yoe5TGP', label: 'LOA', checked: false, type: "checkbox" },
          { uuid: 'MEVZMQNn', label: 'LTD', checked: false, type: "checkbox" },
          { uuid: 'H9HHlcwN', label: 'STD', checked: false, type: "checkbox" },
          { uuid: 'H9HHKQNn', label: 'Benefit Calculations', checked: false, type: "checkbox" },
        ],
      },
      {
        name: 'Health',
        inputs: [
          { uuid: 'H3AltSrK', label: 'Health-All', checked: false, type: "checkbox" },
        ],
      },
      {
        name: 'Wealth',
        inputs: [
          { uuid: 'W1PenSiN', label: 'Pension', checked: false, type: "checkbox" },
          { uuid: 'W2SavngS', label: 'Savings', checked: false, type: "checkbox" },
        ],
      },
    ],
  },
  {
    title: 'Privacy',
    inputs: [
      { uuid: 'cB2AYkVl', label: 'PII', checked: false, type: "checkbox" },
      { uuid: '6kidmu2B', label: 'PHI', checked: false, type: "checkbox" },
    ],
  },
];

export const coldStartDefaultTooltip = { message: "When enabled, this content will be displayed as the default content on the end user's home page" };

export const summaryHelperText = { message: "This is the content summary that will be displayed to end users" };

// Admin: manage content
export const adminContentFilterMapping = {
  reportingType: {
    selectedField: 'selectedReportingType',
    overflowTextField: 'reportingTypeOverflowText',
    displayText: 'Reporting type',
  },
  contentType: {
    selectedField: 'selectedContentType',
    overflowTextField: 'contentTypeOverflowText',
    displayText: 'Content type',
  }
}

export const emptySchedule = {
  subscriptionName: [''],
  frequency: [''],
  dailyOption: [''],
  monday: [false],
  tuesday: [false],
  wednesday: [false],
  thursday: [false],
  friday: [false],
  saturday: [false],
  sunday: [false],
  notification: [true],
  repeatDays: [''],
  weeklyRepeat: [''],
  monthlyOption: [''],
  selectedMonth: [''],
  weekOfMonthSelected: [''],
  weekOfMonth: [''],
  daysOfTheMonthSelected: [''],
  format: ['PDF'],
  daysOfTheMonth: [''],
  time: [''],
  timezone: [''],
  startDate: [''],
  endDate: [''],
  calendarDays: [''],
  daysSelected: [''],
  weeklyOption: [''],
  monthSelected: [''],
  Jan: [false],
  Feb: [false],
  Mar: [false],
  Apr: [false],
  May: [false],
  Jun: [false],
  Jul: [false],
  Aug: [false],
  Sep: [false],
  Oct: [false],
  Nov: [false],
  Dec: [false]
}

export const numOfDaysInMonth = {
  'jan': 31, 'feb': 28, 'mar': 31, 'apr': 30, 'may': 31, 'jun': 30, 'jul': 31, 'aug': 31, 'sep': 30, 'oct': 31, 'nov': 30, 'dec': 31
}

export const daysOfWeekNumbers = {
  'sunday': 1, 'monday': 2, 'tuesday': 3, 'wednesday': 4, 'thursday': 5, 'friday': 6, 'saturday': 7
}

export const SESSION_STORAGE_KEYS = {
  SAML_ERROR: 'saml-error',
  CHAT_HISTORY: 'chat_history',
  CHAT_SESSION: 'chat_session',
  QUICKSIGHT_REGISTERED_KEY: 'quicksight_registration_complete'
}

export const isDevelopmentEnvironment = () => window.location.href.includes('my-qs-app.net:4200') || window.location.href.includes('https://arap.dev.ap.alight.com/');

export const isDevOrQCEnvironment = () => isDevelopmentEnvironment() || window.location.href.includes('https://arap.qc.ap.alight.com/');

// Schedule Subscription Constants
export const SUBSCRIPTION_BREADCRUMBS = [
  { name: "Home", url: "/" },
  { name: "Reports & Dashboards", url: "/reports-and-dashboards" },
  { name: "Subscribe", url: "/reports-and-dashboards" },
];

export const FREQUENCY_OPTIONS = [
  { uuid: "daily", value: "daily", name: "Daily", selected: false },
  { uuid: "weekly", value: "weekly", name: "Weekly", selected: false },
  { uuid: "monthly", value: "monthly", name: "Monthly", selected: false },
  { uuid: "yearly", value: "yearly", name: "Yearly", selected: false },
];

export const DAILY_OPTIONS = [
  {
    initialValue: "onDays",
    labelText: "On day(s) ",
    selected: false,
    disabled: false,
  },
  {
    initialValue: "everyWeekday",
    labelText: "Every weekday ",
    selected: false,
    disabled: false,
  },
  {
    initialValue: "repeatAfter",
    labelText: "Repeat after this number of days ",
    selected: false,
    disabled: false,
  },
];

export const REPEAT_AFTER_OPTIONS = [
  { value: "1", name: "1", selected: false },
  { value: "2", name: "2", selected: false },
  { value: "3", name: "3", selected: false },
  { value: "4", name: "4", selected: false },
  { value: "5", name: "5", selected: false },
  { value: "6", name: "6", selected: false },
];

export const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const MONTHS_OF_YEAR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTHLY_OPTIONS = [
  { value: "onWeekOfMonth", name: "On week of month ", selected: false },
  { value: "onCalendarDays", name: "On calendar day(s) ", selected: false },
];

export const WEEKLY_REPEAT_OPTIONS = [
  { value: "1", name: "Every week", selected: false },
  { value: "2", name: "Every 2 weeks", selected: false },
  { value: "3", name: "Every 3 weeks", selected: false },
  { value: "4", name: "Every 4 weeks", selected: false },
];

export const WEEK_OF_MONTH = [
  { value: "1", name: "1", selected: false },
  { value: "2", name: "2", selected: false },
  { value: "3", name: "3", selected: false },
  { value: "4", name: "4", selected: false },
];

// Time options with 12-hour format (1-12)
export const TIME_OPTIONS = [
  { value: 12, name: "12", selected: false },
  { value: 1, name: "1", selected: false },
  { value: 2, name: "2", selected: false },
  { value: 3, name: "3", selected: false },
  { value: 4, name: "4", selected: false },
  { value: 5, name: "5", selected: false },
  { value: 6, name: "6", selected: false },
  { value: 7, name: "7", selected: false },
  { value: 8, name: "8", selected: false },
  { value: 9, name: "9", selected: false },
  { value: 10, name: "10", selected: false },
  { value: 11, name: "11", selected: false },
];

// AM/PM options
export const AMPM_OPTIONS = [
  { value: "AM", name: "AM", selected: false },
  { value: "PM", name: "PM", selected: false },
];

export const MONTH_WEEKS = {
  "1": "1-7",
  "2": "8-14",
  "3": "15-21",
  "4": "22-28",
};

export const WEEKLY_REPEAT_CODE = {
  "1": "?",
  "2": "1-7,14-21",
  "3": "1-7,21-28",
  "4": "1-7",
};

export const MONTHS_WITH_DAYS = [
  { name: "Jan", value: 1, days: 31 },
  { name: "Feb", value: 2, days: 28 },
  { name: "Mar", value: 3, days: 31 },
  { name: "Apr", value: 4, days: 30 },
  { name: "May", value: 5, days: 31 },
  { name: "Jun", value: 6, days: 30 },
  { name: "Jul", value: 7, days: 31 },
  { name: "Aug", value: 8, days: 31 },
  { name: "Sep", value: 9, days: 30 },
  { name: "Oct", value: 10, days: 31 },
  { name: "Nov", value: 11, days: 30 },
  { name: "Dec", value: 12, days: 31 },
];

// Generate minute options (0-59)
export const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, i) => ({
  value: i,
  name: i.toString().padStart(2, "0"),
  selected: false,
}));


// Product ID mapping constants
export const LEAVES_PRODUCT_IDS = ['STD', 'LTD', 'FMLA', 'LOA', 'ADA', 'Benefit Calculations'];
export const HEALTH_PRODUCT_IDS = ['Health', 'Health-All'];
export const PENSION_PRODUCT_IDS = ['Pension', 'DB Solutions'];
export const SAVINGS_PRODUCT_IDS = ['Savings', 'DC Solutions'];

// Persona ID mapping constants
export const LEAVES_PERSONA_IDS = ['HR', 'Supervisor'];
export const HEALTH_PERSONA_IDS = ['Health-All', 'Health'];